export const components = {
  transcript: {
    titleTranscript: 'Transcription',
    titleLikelyToRemember: 'Customer likely to remember',
    titleSentiment: 'Sentiment analysis',
    titleKeywords: 'Keywords and important phrases',
    empty: '⌛️ Our AI is processing the analysis.Usually it takes 2-3 minutes after recording is sent.',
    error:
      '🤔 Our AI didn’t identfy the language of recording or something went wrong. Please contact with our support if you need help.',
    filler: 'Filler words:',
    energy: 'Positive attitude:',
    keywords: '(1)[Said {{count}} time];(2-inf)[Said {{count}} times];',
    aiTitle: 'AI Analysis',
    scrollButton: 'Hook to autoscroll',
    allGood: 'All good',
  },
  leaderboard: {
    noUsers: 'No users yet',
    noScoreTeamTitle: 'Team Leaderboard',
    noScoreTaskTitle: 'Task Leaderboard',
    noScoreTeam: 'You will see team scores and top-performers once your and/or other recordings will be assessed 🏆',
    noScoreTask: 'You will see scores and top-performers once your and/or other recordings will be assessed 🎲',
    title: 'Best recording:',
    companyTitle: 'Team leaderboard:',
    header: {
      name: 'Name',
      score: 'Score',
    },
    tooltipTeam: {
      title: 'Here is list of team top-performers whose recordings are assessd by manager and AI.',
      description: 'Team leaderboard shows the sum of all tasks with feedback.',
    },
    tooltipTask: {
      title: 'Here is list of top-performers whose recording is assessed by manager and AI.',
      description1:
        'Manager assess the rating criteria and AI shows how clear and positive your language. Based on amount of filler words and postive attitude. Max score for each criterium is 5.',
      description2: 'Max task score is 35.',
    },
  },
};
